import { lazy } from "react";

const list = lazy(() => import("./List").then(m => ({ default: m.PortalSubmittedList })));
const edit = lazy(() => import("./Edit").then(m => ({ default: m.PortalSubmittedEdit })));

export default { list, edit };
